import { usePostAuthLogoutMutation } from '../../store/backendApi';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { PageProps } from '../../shell/shell';

export const SignOutPage = (props: PageProps) => {
  const [signOutAction, { data, error }] = usePostAuthLogoutMutation();

  useEffect(() => {
    signOutAction();
  }, []);

  if (data) {
    return <Navigate to="/login" />;
  } else {
    console.error(error);
  }
  return <p>Logout...</p>;
};
